import { useState, useRef, useEffect } from 'react'
import DeleteCMLModal from './DeleteCMLModal'
import EditLessonResourceModal from './EditLessonResourceModal'
const LessonResources = ({ lesson, openResources, fetchCourseContent }) => {
  const [openDropdownIndex, setOpenDropdownIndex] = useState(null)
  const [deleteId, setDeleteId] = useState(null)
  const [editId, setEditId] = useState(null)
  const [editLessonModal, setEditLessonModal] = useState(false)
  const dropdownRef = useRef(null)
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setOpenDropdownIndex(null)
      }
    }
    document.addEventListener('mousedown', handleClickOutside)
    return () => {
      document.removeEventListener('mousedown', handleClickOutside)
    }
  }, [])
  const handleEditLesson = (resource) => {
    setEditId(resource.id)   
    setEditLessonModal(true) 
    setOpenDropdownIndex(null)
  }
  return (
    <>
      {lesson.resources?.length > 0 && openResources === lesson.id && (
  <div className="mt-3 space-y-2">
    {lesson.resources.map((resource, index) => (
      <div key={index} className="flex items-center justify-between p-3 bg-gray-50 rounded-xl hover:bg-gray-100 transition-colors relative">
        {/* CLICKABLE LINK */}
        <a
          href={resource.file}
          target="_blank"
          rel="noopener noreferrer"
          className="flex items-center gap-3 flex-1 min-w-0"
        >
          <div className="w-6 h-6 bg-white rounded-lg flex items-center justify-center flex-shrink-0">
            <span className="text-xs font-medium text-gray-600">{index + 1}</span>
          </div>
          <span className="text-sm text-gray-700 truncate">{resource.file.split('/').pop()}</span>
        </a>
        {/* THREE DOTS MENU */}
        <div
          className="w-8 h-8 flex items-center justify-center rounded-lg text-gray-500 cursor-pointer hover:bg-gray-200 transition-colors"
          onClick={(e) => {
            e.stopPropagation();
            e.preventDefault();
            setOpenDropdownIndex(openDropdownIndex === resource.id ? null : resource.id);
          }}
        >
          <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M12 5v.01M12 12v.01M12 19v.01M12 6a1 1 0 110-2 1 1 0 010 2zm0 7a1 1 0 110-2 1 1 0 010 2zm0 7a1 1 0 110-2 1 1 0 010 2z" />
          </svg>
        </div>
        {/* DROPDOWN MENU */}
        {openDropdownIndex === resource.id && (
          <div
            ref={dropdownRef}
            className="absolute right-0 top-full mt-1 bg-white rounded-xl shadow-lg border border-gray-200 py-1 min-w-[140px] z-50"
          >
            <div
              className="flex items-center gap-3 px-4 py-2.5 text-sm text-gray-700 hover:bg-gray-50 cursor-pointer transition-colors"
              title="Edit Resource"
              onClick={() => handleEditLesson(resource)}
            >
              <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M11 5H6a2 2 0 00-2 2v11a2 2 0 002 2h11a2 2 0 002-2v-5m-1.414-9.414a2 2 0 112.828 2.828L11.828 15H9v-2.828l8.586-8.586z" />
              </svg>
              Edit
            </div>

            <div
              className="flex items-center gap-3 px-4 py-2.5 text-sm text-red-500 hover:bg-red-50 cursor-pointer transition-colors"
              title="Delete Resource"
              onClick={() => setDeleteId(resource.id)}
            >
              <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16" />
              </svg>
              Delete
            </div>
          </div>
        )}
      </div>
    ))}
  </div>
)}
      {/* DELETE MODAL */}
      <DeleteCMLModal
        deleteId={deleteId}
        setDeleteId={setDeleteId}
        type="resource"
        fetchCourseContent={fetchCourseContent}
      />
      {/* EDIT MODAL */}
      {editLessonModal && editId !== null && (
        <EditLessonResourceModal
          resourceId={editId}
          setEditLessonModal={setEditLessonModal}
          fetchCourseContent={fetchCourseContent}
        />
      )}
    </>
  )
}

export default LessonResources
